import { Modal } from 'antd';
import React from 'react';
import TablePatientList from '../../pages/patientList/tablePatientList';
import { useBreakpoint } from '../../../../hooks/useBreakpoint';

export default function ModalClient({ modalType, modalClient, setmodalClient, setPayClient, setCompanion }:any) {

  const breakPoint = useBreakpoint();

  function rowClick(pacient: any) {
    if(modalType === "payClient"){
      setPayClient(pacient);
    }
    if(modalType === "companion"){
      setCompanion(pacient);
    }
    setmodalClient(false);
  }

  return (
    <Modal
      title="Cliente pagador"
      visible={modalClient}
      footer={null}
      width={breakPoint.isDesktop ? 928 : 656}
      onCancel={() => setmodalClient(false)}
      destroyOnClose
      bodyStyle={{ padding: 0 }}
    >
      <div className="patient-new">
        <TablePatientList rowClick={rowClick} pageSize={5} />
      </div>
    </Modal>
  );
}
